// List of common mime types for the web, based on https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
export const mimeTypes = [
  {
    extension: "epub",
    mimeType: "application/epub+zip",
  },
  {
    extension: "gz",
    mimeType: "application/gzip",
  },
  {
    extension: "jar",
    mimeType: "application/java-archive",
  },
  {
    extension: "json",
    mimeType: "application/json",
  },
  {
    extension: "jsonld",
    mimeType: "application/ld+json",
  },
  {
    extension: "doc",
    mimeType: "application/msword",
  },
  {
    extension: "bin",
    mimeType: "application/octet-stream",
  },
  {
    extension: "ogx",
    mimeType: "application/ogg",
  },
  {
    extension: "pdf",
    mimeType: "application/pdf",
  },
  {
    extension: "rtf",
    mimeType: "application/rtf",
  },
  {
    extension: "azw",
    mimeType: "application/vnd.amazon.ebook",
  },
  {
    extension: "mpkg",
    mimeType: "application/vnd.apple.installer+xml",
  },
  {
    extension: "xul",
    mimeType: "application/vnd.mozilla.xul+xml",
  },
  {
    extension: "xls",
    mimeType: "application/vnd.ms-excel",
  },
  {
    extension: "eot",
    mimeType: "application/vnd.ms-fontobject",
  },
  {
    extension: "ppt",
    mimeType: "application/vnd.ms-powerpoint",
  },
  {
    extension: "odp",
    mimeType: "application/vnd.oasis.opendocument.presentation",
  },
  {
    extension: "ods",
    mimeType: "application/vnd.oasis.opendocument.spreadsheet",
  },
  {
    extension: "odt",
    mimeType: "application/vnd.oasis.opendocument.text",
  },
  {
    extension: "pptx",
    mimeType: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  },
  {
    extension: "xlsx",
    mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  },
  {
    extension: "docx",
    mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  },
  {
    extension: "rar",
    mimeType: "application/vnd.rar",
  },
  {
    extension: "vsd",
    mimeType: "application/vnd.visio",
  },
  {
    extension: "7z",
    mimeType: "application/x-7z-compressed",
  },
  {
    extension: "abw",
    mimeType: "application/x-abiword",
  },
  {
    extension: "bz",
    mimeType: "application/x-bzip",
  },
  {
    extension: "bz2",
    mimeType: "application/x-bzip2",
  },
  {
    extension: "cda",
    mimeType: "application/x-cdf",
  },
  {
    extension: "csh",
    mimeType: "application/x-csh",
  },
  {
    extension: "arc",
    mimeType: "application/x-freearc",
  },
  {
    extension: "xhtml",
    mimeType: "application/xhtml+xml",
  },
  {
    extension: "php",
    mimeType: "application/x-httpd-php",
  },
  {
    extension: "sh",
    mimeType: "application/x-sh",
  },
  {
    extension: "swf",
    mimeType: "application/x-shockwave-flash",
  },
  {
    extension: "tar",
    mimeType: "application/x-tar",
  },
  {
    extension: "zip",
    mimeType: "application/zip",
  },
  {
    extension: "aac",
    mimeType: "audio/aac",
  },
  {
    extension: "mid",
    mimeType: "audio/midi-audio/x-midi",
  },
  {
    extension: "mid",
    mimeType: "audio/midi-audio/x-midi",
  },
  {
    extension: "mp3",
    mimeType: "audio/mpeg",
  },
  {
    extension: "oga",
    mimeType: "audio/ogg",
  },
  {
    extension: "opus",
    mimeType: "audio/opus",
  },
  {
    extension: "wav",
    mimeType: "audio/wav",
  },
  {
    extension: "weba",
    mimeType: "audio/webm",
  },
  {
    extension: "otf",
    mimeType: "font/otf",
  },
  {
    extension: "ttf",
    mimeType: "font/ttf",
  },
  {
    extension: "woff",
    mimeType: "font/woff",
  },
  {
    extension: "woff2",
    mimeType: "font/woff2",
  },
  {
    extension: "avif",
    mimeType: "image/avif",
  },
  {
    extension: "bmp",
    mimeType: "image/bmp",
  },
  {
    extension: "gif",
    mimeType: "image/gif",
  },
  {
    extension: "jpeg",
    mimeType: "image/jpeg",
  },
  {
    extension: "jpg",
    mimeType: "image/jpeg",
  },
  {
    extension: "png",
    mimeType: "image/png",
  },
  {
    extension: "svg",
    mimeType: "image/svg+xml",
  },
  {
    extension: "tif",
    mimeType: "image/tiff",
  },
  {
    extension: "tiff",
    mimeType: "image/tiff",
  },
  {
    extension: "ico",
    mimeType: "image/vnd.microsoft.icon",
  },
  {
    extension: "webp",
    mimeType: "image/webp",
  },
  {
    extension: "ics",
    mimeType: "text/calendar",
  },
  {
    extension: "css",
    mimeType: "text/css",
  },
  {
    extension: "csv",
    mimeType: "text/csv",
  },
  {
    extension: "htm",
    mimeType: "text/html",
  },
  {
    extension: "html",
    mimeType: "text/html",
  },
  {
    extension: "mjs",
    mimeType: "text/javascript",
  },
  {
    extension: "txt",
    mimeType: "text/plain",
  },
  {
    extension: "ts",
    mimeType: "video/mp2t",
  },
  {
    extension: "mp4",
    mimeType: "video/mp4",
  },
  {
    extension: "mpeg",
    mimeType: "video/mpeg",
  },
  {
    extension: "ogv",
    mimeType: "video/ogg",
  },
  {
    extension: "webm",
    mimeType: "video/webm",
  },
  {
    extension: "avi",
    mimeType: "video/x-msvideo",
  },
  {
    extension: "mov",
    mimeType: "video/quicktime",
  },
];
